import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { VerificationStepSummary } from "types/admin";
import { VerificationOutcomeChip, kycStatusChipColor } from "./adminKycVerificationUtils";

interface VerificationStepRowProps {
  title: string;
  step?: VerificationStepSummary | null;
}

export function VerificationStepRow({ title, step }: VerificationStepRowProps) {
  const showFailureMessage = step?.outcome === "FAILURE" && step.message;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        py: 1.25,
        px: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="body2" fontWeight={500}>
        {title}
      </Typography>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
        {showFailureMessage && (
          <Typography
            variant="caption"
            color="error.main"
            sx={{ textAlign: "right", maxWidth: { xs: 140, sm: 320 } }}
          >
            {step.message}
          </Typography>
        )}
        <VerificationOutcomeChip step={step} emptyLabel="No log" />
      </Stack>
    </Box>
  );
}

interface KycStatusChipProps {
  status?: string;
}

export function KycStatusChip({ status }: KycStatusChipProps) {
  if (!status) return null;
  return <Chip size="small" color={kycStatusChipColor(status)} label={status} />;
}
